export default class GetLink {
    public static getLinkForItem(items: any, linkName: string) {
        return this.getLinkItem(items, linkName);
    }

    private static getLinkItem(itemsArr: any, linkName: string) {
        let itemFound:boolean = false;
        let itemsRes: any[] = [];
        itemsArr.map((i: any)=>{
            if(!itemFound) {
                if(i.linkName === linkName) {
                    itemsRes.push(i);
                    itemFound = true;
                }
                else {
                    if(i.subItems) {
                        const res = this.getLinkItem(i.subItems, linkName);
                        if(res.length) {
                            itemsRes = [i, ...res];
                        }
                    }
                }
            }
            return true;
        });
        return itemsRes;
    }
}


// WEBPACK FOOTER //
// ./src/helpers/getLink/getLink.ts